import React from "react";
import './dashboard.css'
import SurveillanceDonutChart from "./DonutGraph";
import TotalCompaniesGraph from "./TotalCompaniesGraph";

 

const DashboardGraph = () => {
   
  return (
    <div className="row graph-section">
      {/* Line Chart */}
      <div className="col-lg-8 col-md-8">
         <TotalCompaniesGraph/>
      </div>

      {/* Donut Chart */}
      <div className="col-lg-4 col-md-4">
         <SurveillanceDonutChart/>
      </div>
    </div>
  );
};

export default DashboardGraph;
